import { lazy, Suspense } from "react";

import { MULTI_ANALYSIS_MEASURE_TYPE } from "../../../multi-analysis/types";
import type { IMultiAnalysisDataMark } from "../../../multi-analysis/types";
import type { ISpeedScreenFormContentProps, ISpeedScreenFormStrategy, ISpeedScreenFormTimePanelProps } from "../types";
import { isOrbitPairMark } from "./pair-marks";
import { OrbitTimePanel } from "./time-panel";
import { OrbitDataMarkTooltip } from "./tooltip";

const OrbitScreenForm = lazy(() => import("./view").then(module => ({ default: module.OrbitScreenForm })));

export class OrbitScreenFormStrategy implements ISpeedScreenFormStrategy {
  readonly id = "orbit" as const;
  readonly titleId = "pages.speed.screenForms.orbit";
  readonly measureType = MULTI_ANALYSIS_MEASURE_TYPE.ORBIT;

  render(props: ISpeedScreenFormContentProps) {
    return (
      <Suspense fallback={null}>
        <OrbitScreenForm {...props} />
      </Suspense>
    );
  }

  renderTimePanel(props: ISpeedScreenFormTimePanelProps) {
    return <OrbitTimePanel {...props} />;
  }

  renderDataMarkTooltip(mark: IMultiAnalysisDataMark) {
    return isOrbitPairMark(mark) ? <OrbitDataMarkTooltip mark={mark} /> : null;
  }
}
